import React from "react";
import prevArrow from '../../../styles/img/prevArrow.png'
import nextArrow from '../../../styles/img/nextArrow.png'

export const UiNextArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: 'block' }}
      onClick={onClick}
    >
      <img src={nextArrow} />
    </div>
  );
};

export const UiPrevArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: 'block' }}
      onClick={onClick}
    >
      <img src={prevArrow} />
    </div>
  );
};